// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取用户管理 GET /api/user-list */
export async function getUserList(
  params: UserAPI.UserListParams,
  options?: { [key: string]: any },
) {
  return request<UserAPI.PagingResponse<UserAPI.PersonVO>>('/api/user/', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 分配用户角色 POST /api/user-list/user-list-role */
export async function assignUserRole(
  data: UserAPI.AssignUserRoleItem,
  options?: { [key: string]: any },
) {
  return request('/api/user/user-role', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 重置密码 PUT /api/user-list/reset-password */
export async function resetPassword(
  data: UserAPI.ResetPasswordItem,
  options?: { [key: string]: any },
) {
  return request('/api/user/reset-password', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 解锁人员账号 PUT /api/user/unlock */
export async function unlockPerson(
  data: UserAPI.UnlockPersonItem,
  options?: { [key: string]: any },
) {
  return request('/api/user/unlock', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 启用/禁用用户 PUT /api/user/status */
export async function updateUserStatus(
  data: UserAPI.UpdateUserStatusItem,
  options?: { [key: string]: any },
) {
  return request('/api/user/status', {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 创建用户 POST /api/user */
export async function createPerson(
  data: UserAPI.PersonCreateItem,
  options?: { [key: string]: any },
) {
  return request<API.Response<any>>('/api/user/', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 更新用户 PUT /api/user/person/{pid} */
export async function updatePerson(
  pid: number,
  data: UserAPI.PersonUpdateItem,
  options?: { [key: string]: any },
) {
  return request<API.Response<any>>(`/api/user/person/${pid}`, {
    method: 'PUT',
    data,
    ...(options || {}),
  });
}

/** 删除用户 DELETE /api/user/person/{pid} */
export async function deletePerson(
  pid: number,
  options?: { [key: string]: any },
) {
  return request<API.Response<any>>(`/api/user/person/${pid}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 下载用户导入模版 GET /api/user/import/template */
export async function downloadImportTemplate() {
  return request('/api/user/import/template', {
    method: 'GET',
    responseType: 'blob',
  });
}

/** 批量导入用户 POST /api/user/import */
export async function importUsers(
  file: File,
  options?: { [key: string]: any },
) {
  const formData = new FormData();
  formData.append('file', file);
  return request<API.Response<UserAPI.ImportResultVO>>('/api/user/import', {
    method: 'POST',
    data: formData,
    ...(options || {}),
  });
}

/** 修改密码 POST /api/user/update-password */
export async function updatePassword(
  data: { currentPassword: string; newPassword: string; confirmPassword: string },
  options?: { [key: string]: any },
) {
  return request<any>('/api/user/update-password', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

/** 批量删除用户 POST /api/user/batch-delete */
export async function batchDeleteUsers(
  data: { pids: number[] },
  options?: { [key: string]: any },
) {
  return request<API.Response<any>>('/api/user/batch-delete', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

